import * as React from "react"
import type { SVGProps } from "react"
const SvgEmails = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.5 4.71a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1m0 2a1 1 0 0 0 0 2h13a1 1 0 1 0 0-2z" />
    <path
      fillRule="evenodd"
      d="M3.59 21.13q.59.58 1.41.58h14q.83 0 1.41-.58.6-.6.59-1.42v-8q0-.83-.59-1.4A2 2 0 0 0 19 9.7H5q-.82 0-1.41.6A2 2 0 0 0 3 11.7v8q0 .82.59 1.42m15.41-8-6.09 3.12a2 2 0 0 1-1.82 0L5 13.14v6.58h14zm-12.55-1.4L12 14.26l5.5-2.55z"
    />
  </svg>
)
export default SvgEmails
